var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#F5F1FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 20.5C25 21.2956 24.6839 22.0587 24.1213 22.6213C23.5587 23.1839 22.7956 23.5 22 23.5C21.2044 23.5 20.4413 23.1839 19.8787 22.6213C19.3161 22.0587 19 21.2956 19 20.5C19 19.7044 19.3161 18.9413 19.8787 18.3787C20.4413 17.8161 21.2044 17.5 22 17.5C22.7956 17.5 23.5587 17.8161 24.1213 18.3787C24.6839 18.9413 25 19.7044 25 20.5Z",
    stroke: "#8046F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 20.5C29.5 27.642 22 31.75 22 31.75C22 31.75 14.5 27.642 14.5 20.5C14.5 18.5109 15.2902 16.6032 16.6967 15.1967C18.1032 13.7902 20.0109 13 22 13C23.9891 13 25.8968 13.7902 27.3033 15.1967C28.7098 16.6032 29.5 18.5109 29.5 20.5Z",
    stroke: "#8046F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.fede64ef95c1336abc0c60e280e36a36.svg";
export { ForwardRef as ReactComponent };